// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "1.5.16/static/js/" + chunkId + "." + "96e4c809" + ".chunk.js";
};